import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import YekgLogo from "../../assets/img/yekg-logo.svg";
import Button from "../../components/Button/Button";
import { Input } from "../../components/Inputs";
import { API_PORTAL, API_POST } from "../../helpers/api";
import { setNotification } from "../../helpers/notification";
import { setPortalData } from "../../redux/actions/portal";
import { useTranslation } from "react-i18next";
import Turkey from "../../assets/img/turkey.svg";
import UK from "../../assets/img/united-kingdom.svg";

import Reaptcha from "reaptcha";

export default function Form(props) {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const [lang, setLang] = useState(window.localStorage.getItem("i18nextLng"));
  const [isLangOpen, setIsLangOpen] = useState(false);

  const [formData, setFormData] = useState({
    identityNo: "",
    redemptionNo: "",
  });

  const [formErrors, setFormErrors] = useState({
    identityNo: false,
    redemptionNo: false,
  });

  const [captchaStatus, setCaptchaStatus] = useState({
    loaded: false,
    rendered: false,
    verified: false,
  });

  let CAPTCHA;

  const [loading, setLoading] = useState(false);

  const captchaLoad = () => {
    setCaptchaStatus({ ...captchaStatus, loaded: true });
  };

  const captchaRender = () => {
    setCaptchaStatus({ ...captchaStatus, rendered: true });
  };

  const captchaVerify = () => {
    setCaptchaStatus({ ...captchaStatus, verified: true });
  };

  const formDataChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (e.target.name === "identityNo" && e.target.value.length === 11) {
      setFormErrors({ ...formErrors, identityNo: false });
    }
    if (e.target.name === "redemptionNo" && e.target.value.length === 10) {
      setFormErrors({ ...formErrors, redemptionNo: false });
    }
  };

  const validateForm = () => {
    let errors = [false, false, false, false];
    if (
      formData.identityNo.length !== 11 &&
      formData.identityNo.length !== 10
    ) {
      errors[0] = true;
    }
    if (formData.redemptionNo.length !== 10) {
      errors[1] = true;
    }
    if (!captchaStatus.rendered && !captchaStatus.verified) {
      CAPTCHA.renderExplicitly();
      errors[2] = true;
    }
    if (!captchaStatus.verified) {
      errors[3] = true;
    }
    if (errors[0] || errors[1]) {
      setNotification("error", t("pages.default.portal.errors.wrongInfo"));
      setFormErrors({ identityNo: errors[0], redemptionNo: errors[1] });
    }
    if (!errors[0] && !errors[1] && errors[3]) {
      setNotification(
        "error",
        t("pages.default.portal.errors.verificationStep")
      );
    }
    if (errors.includes(true)) {
      return false;
    }
    return true;
  };

  const formSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    try {
      setLoading(true);
      let res = await API_PORTAL("portal/redemption/validate", {
        redemptionId: formData.redemptionNo,
        taxOrIdentityNumber: formData.identityNo,
      });
      dispatch(setPortalData(res.data));
      props.history.push("/portal/result");
    } catch (err) {
      let message = "";
      if (err.response.data.status === "NOT_FOUND") {
        message = t("pages.default.portal.errors.cancellationNotFound");
      }
      if (err.response.data.status === "BAD_REQUEST") {
        message = err.response.data.message;
      }
      setNotification("error", message);
      setLoading(false);
    }
  };

  const checkActiveLang = () => {
    return lang === "en";
  };
  const switchLang = async () => {
    if (checkActiveLang()) {
      setLang("tr");
      window.localStorage.setItem("i18nextLng", "tr");
    } else {
      setLang("en");
      window.localStorage.setItem("i18nextLng", "en");
    }
    window.location.reload();
  };

  return (
    <div className="km__p--portal">
      <div className="km__p--portal-form-container">
        <div className="km__p--portal-switch-container">
          <div
            className="km__c--avatar-wrapper km__c--avatar-is-lang"
            onBlur={() => setIsLangOpen(false)}
            tabIndex="0"
          >
            <div
              className="km__c--avatar-container"
              onClick={() => setIsLangOpen(true)}
            >
              <img src={lang === "en" ? UK : Turkey} alt={lang} />
            </div>
            <div
              className={`km__c--avatar-menu-container ${
                isLangOpen ? "km__c--avatar-menu-is-open" : ""
              }`}
            >
              <div
                className="km__c--avatar-menu-item"
                onClick={() => switchLang("en")}
              >
                English
              </div>

              <div
                className="km__c--avatar-menu-item"
                onClick={() => switchLang("tr")}
              >
                Türkçe
              </div>
            </div>
          </div>
        </div>
        <div className="km__p--portal-header">
          <img
            src={YekgLogo}
            className="km__p--portal-logo"
            alt={t("pages.default.top.title")}
          />
          <p className="km__p--portal-text">{t("pages.default.top.title")}</p>
        </div>
        <form onSubmit={formSubmit}>
          <Input
            label={t("pages.default.portal.form.input.identityNo.label")}
            placeholder={t(
              "pages.default.portal.form.input.identityNo.placeholder"
            )}
            name="identityNo"
            style={{ marginBottom: "10px" }}
            onChange={formDataChange}
            error={formErrors.identityNo}
          />
          <Input
            label={t("pages.default.portal.form.input.redemptionNo.label")}
            placeholder={t(
              "pages.default.portal.form.input.redemptionNo.placeholder"
            )}
            name="redemptionNo"
            style={{ marginBottom: "40px" }}
            onChange={formDataChange}
            error={formErrors.redemptionNo}
          />
          <Button
            label={t("pages.default.portal.form.submit")}
            style={{ marginRight: "auto", marginLeft: "auto" }}
            onClick={formSubmit}
            disabled={loading}
          />
          <Reaptcha
            ref={(e) => {
              CAPTCHA = e;
            }}
            sitekey="6Lf3DsoaAAAAAPtstG6_Ru-aAec4YHNTDrDp77rB"
            hl={lang}
            onLoad={captchaLoad}
            onRender={captchaRender}
            onVerify={captchaVerify}
            explicit={true}
          />
        </form>
      </div>
    </div>
  );
}
